module.exports = __webpack_public_path__ + "static/img/chenpi.8391444f.png";